import api from "./api";

export const listHelpCategories = () => api.get("/help-categories");

export const createHelpCategory = (name) => api.post("/help-categories", { name });

export const updateHelpCategory = (id, name) => api.put(`/help-categories/${id}`, { name });

export const deleteHelpCategory = (id) => api.delete(`/help-categories/${id}`);
